<template>
    <div class="options">
        <div class="option"
             v-for="(option, index) of options"
             :key="index"
             :class="{active: option === selectedOption}"
             :style="{width: optionWidth}"
             @click="onSelect(option)">
            <img v-if="option === selectedOption"
                 src="../../assets/img/check-white.svg">
            <span>{{ formatCallback(option) }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Choice',
        props: {
            options: Array,
            formatCallback: {
                type: Function,
                default: el => el
            },
            optionWidth: {
                type: String,
                default: '155px'
            },
            autoChoice: {
                type: Boolean,
                default: true
            },
            value: [Object, String]
        },
        data() {
            return {
                selectedOption: this.autoChoice ? this.options[0] : ''
            }
        },
        watch: {
            value: {
                handler() {
                    if (this.value) {
                        this.selectedOption = this.value;
                    }
                },
                immediate: true
            },
            selectedOption: {
                handler(option) {
                    this.$emit('input', option);
                },
                immediate: false
            }
        },
        methods: {
            onSelect(option) {
                this.selectedOption = option;
            }
        },
        mounted() {
            this.$emit('select', this.selectedOption);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/colors";

    .options {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 33px;
        .option {
            border-radius: 4px;
            min-height: 48px;
            background: $ComplementaryBgTxtDarker;
            font-family: Asap-Medium;
            position: relative;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            color: $WhiteGrey;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.14;

            &:first-child {
                border-radius: 4px 0 0 4px;
            }

            &:last-child {
                border-radius: 0 4px 4px 0;
            }
        }
        .active {
            background: $LightBlue;
            color: $WhiteDirty;
            border-radius: 4px !important;
            > img {
                margin-right: 4px;
                width: 16px;
                height: 16px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/Choice.vue